// #region Imports
import notify from 'devextreme/ui/notify';
import { markRaw } from 'vue';
import { showToast, updateToast, showOrUpdateToast, removeToast, withToast } from '../composables/useToast';
// #endregion
export default class NotificationFactory {
    // #region Helper
    hasOpenWindows() {
        return appHost.store.get("windows").modalWindows.length > 0;
    }
    getWindowByID(id) {
        return appHost.store.get("windows").modalWindows.find(e => e.id === id);
    }
    getLastWindow() {
        let tWindows = appHost.store.get("windows").modalWindows;
        {
            if (tWindows.length > 0) {
                return tWindows[tWindows.length - 1];
            }
            else {
                return null;
            }
        }
    }
    // #endregion
    // #region Core
    alert(message) {
        alert(message);
    }
    showToast(message, type = "success") {
        if (utils.isNullOrEmpty(message)) {
            return;
        }
        notify({ message: message, width: 500, type: type }, { direction: "up-push", position: "bottom center" });
    }
    showToast2(options) {
        return showToast(options);
    }
    updateToast2(id, options) {
        updateToast(id, options);
    }
    showOrUpdateToast2(id, options) {
        return showOrUpdateToast(id, options);
    }
    removeToast2(id) {
        return removeToast(id);
    }
    withToast2(work, options) {
        return withToast(work, options);
    }
    closeModal(id) {
        //Vars
        let tWindows = appHost.store.get("windows").modalWindows;
        //Find
        const index = tWindows.findIndex((v) => v.id === id);
        //Remove
        if (index !== -1) {
            //Remove
            tWindows.splice(index, 1);
            //Scrollbar
            if (tWindows.length === 0) {
                appHost.pageMeta.scrollbarShow();
            }
        }
    }
    async updateModal(id, componentProps, modalProps, modalEvents) {
        //Find
        let tWindow = appHost.store.get("windows").modalWindows.find((v) => v.id === id);
        if (!tWindow) {
            return;
        }
        if (componentProps) {
            //vars
            const defaults = {};
            //Set
            tWindow.componentAttrs = { ...defaults, ...componentProps };
        }
        if (modalProps) {
            //vars
            const name = id;
            const type = modalProps.variant == "slide" ? "g-modal-slide" : "g-modal-popup";
            //Values
            modalProps.name = name;
            //Set     
            tWindow.windowType = type;
            tWindow.windowAttrs = { ...modalProps, name, id };
        }
    }
    showModal(compontent, componentProps, modalProps = { variant: "popup", position: "center", size: "default" }, modalEvents) {
        // #region Vars
        const name = modalProps.name || "__modal_" + utils.createId();
        const id = name;
        const type = modalProps.variant == "slide" ? "g-modal-slide" : "g-modal-popup";
        const defaults = {};
        // #endregion
        // #region Component
        let tComponent;
        {
            if (utils.isString(compontent)) {
                tComponent = appHost.components.getComponent(compontent);
            }
            else {
                tComponent = compontent;
            }
            if (!tComponent) {
                return;
            }
        }
        // #endregion
        // #region Optimize
        markRaw(tComponent);
        // #endregion
        // #region Parent
        utils.logDebug("showModal", this.getLastWindow());
        // #endregion
        // #region Show
        let tWindow = {
            id,
            component: tComponent,
            componentAttrs: { ...defaults, ...componentProps },
            modalEvents,
            appWindow: null,
            windowType: type,
            windowAttrs: {
                ...modalProps,
                name,
                id,
                parentWindow: this.getLastWindow()?.appWindow ?? appHost.mainWindow,
            }
        };
        //Scrollbar
        if (appHost.store.get("windows").modalWindows.length === 0) {
            appHost.pageMeta.scrollbarHide();
        }
        //Show
        appHost.store.get("windows").modalWindows.push(tWindow);
        // #endregion 
    }
    async showModal2(compontent, componentProps, modalProps = { variant: "popup", position: "center", size: "default" }, modalEvents) {
        return new Promise((resolve, reject) => {
            // #region Vars
            const name = modalProps.name || "__modal_" + utils.createId();
            const id = name;
            const type = modalProps.variant == "slide" ? "g-modal-slide" : "g-modal-popup";
            const defaults = {};
            // #endregion
            // #region Component
            let tComponent;
            if (utils.isString(compontent)) {
                tComponent = appHost.components.getComponent(compontent);
            }
            else {
                tComponent = compontent;
            }
            if (!tComponent) {
                resolve({ state: dialogResultState.Abort });
                return;
            }
            // #endregion
            // #region Optimize
            markRaw(tComponent);
            // #endregion
            // #region Show
            let tWindow = {
                id,
                component: tComponent,
                componentAttrs: { ...defaults, ...componentProps },
                modalEvents,
                appWindow: null,
                windowType: type,
                windowAttrs: {
                    ...modalProps,
                    name,
                    id,
                    type,
                    parentWindow: this.getLastWindow()?.appWindow ?? appHost.mainWindow,
                    windowCallback: resolve
                },
            };
            //Scrollbar
            if (appHost.store.get("windows").modalWindows.length === 0) {
                appHost.pageMeta.scrollbarHide();
            }
            //Show
            appHost.store.get("windows").modalWindows.push(tWindow);
            // #endregion 
        });
    }
    showError(errorObject) {
        if (!errorObject) {
            return;
        }
        if (errorObject?.isAxiosError) {
            this.showToast(utils.getAxiosErrorMessage(errorObject), 'error');
        }
        else if (errorObject instanceof Error) {
            this.showToast(errorObject.message, 'error');
        }
        else {
            this.showToast(utils.getAxiosErrorMessage(errorObject), 'error');
        }
    }
    showErrorMessage(args) {
        this.showModal("g-messages-error", args, { size: 'large' });
    }
    showQuestion(args) {
        this.showModal("g-messages-question", args, { size: 'default' });
    }
    async showQuestionAsync(args) {
        return await this.showModal2("g-messages-question", args, { size: 'default' });
    }
}
